import moment from "moment";
class logs {
  constructor(dateE, errorId, comment) {
    this.dateE = moment(dateE).utc().format("DD-MM-YYYY");
    this.errorId = errorId;
    this.comment = comment == null ? "Sin comentarios" : comment;
  }
  static fromJson({ fechaE, errorId, comentario }) {
    return new logs(fechaE, errorId, comentario);
  }
}
export default logs;
